import * as ActionTypes from '@/store/mutations/design/type'

export default {
  // 设置当前编辑的iframe的src路径
  designSetIframeSrc: ({ commit }, params) => {
    commit(ActionTypes.SAVE_DESIGN_SRC, params)
  },
  // 设置 ref
  designSetIframeRef: ({ commit }, params) => {
    commit(ActionTypes.SAVE_DESIGN_REF, params)
  },
  // 设置 pageId
  designSetIframePageId: ({ commit }, params) => {
    commit(ActionTypes.SAVE_DESIGN_PAGE_ID, params)
  },
  designRefreshPage: ({ commit }, params) => {
    commit(ActionTypes.REFRESH_PAGE)
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/design/design.js